import React from 'react';
import { getContext, I18nProvider } from '@fiverr-private/fiverr_context';
import { bigQuery, mixpanel } from '@fiverr-private/obs';
import { baseTranslationButtonProps } from '../../../utils/props';
import { EventTypes } from '../../../utils/events/constants';
import { BigQueryEvents } from '../../../utils/events/bigQuery';
import { MixpanelEvents } from '../../../utils/events/mixpanel';
import { MixpanelEventTypes } from '../../../utils/events/mixpanel/types';

const withTranslationButtonWrapper = (TranslationButton) => {

    const TranslationButtonWrapper = ({
        onClick = Function.prototype,
        sourceInfo = {},
        ...props
    }) => {
        const { locale } = getContext();

        const handleClick = () => {
            props.toggled ?
                reportTranslationCancelledEvent() :
                reportTranslatedEvent();

            onClick();
        };

        const reportTranslatedEvent = () => {
            reportEvent(EventTypes.clickedOnTranslationButton);
        };

        const reportTranslationCancelledEvent = () => {
            reportEvent(EventTypes.clickedOnCancelledTranslationButton);
        };

        const reportEvent = (eventKey) => {
            reportBigQueryEvent(eventKey);
            reportMixpanelEvent(eventKey);
        };

        const reportBigQueryEvent = (eventKey) => {
            const bigQueryEventBuilder = BigQueryEvents.userActions[eventKey];

            bigQuery.send(bigQueryEventBuilder({
                targetLocale: locale,
                sourceInfo
            }));
        };

        const reportMixpanelEvent = (eventKey) => {
            const mixpanelEventType = MixpanelEventTypes.translation[eventKey];
            const mixpanelEventBuilder = MixpanelEvents.userActions[eventKey];

            mixpanel.track(mixpanelEventType, mixpanelEventBuilder({
                targetLocale: locale,
                sourceInfo
            }));
        };

        return (
            <I18nProvider>
                {({ i18n }) => (
                    <TranslationButton onClick={handleClick} i18n={i18n} {...props}/>
                )}
            </I18nProvider>
        );
    };

    TranslationButtonWrapper.propTypes = baseTranslationButtonProps;

    return TranslationButtonWrapper;
};

export default withTranslationButtonWrapper;
